// PriceCalculatorHeader.tsx

export const PriceCalculatorHeader = () => (
  <div className="flex flex-col items-center gap-2 self-stretch relative ">
    <img
      className="absolute -left-28 top-4"
      src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Sketch-annotation-element-stroke-line-arrow-spiral-up.svg"
      alt=""
    />
    <h1 className="text-[color:var(--Shade-Wh1te,#FFF)] text-center text-[44px] not-italic font-bold leading-[normal]">
      Linkedin Pricing Calculator
    </h1>
    <h2 className="text-[#919191] text-center text-base font-normal leading-7 tracking-[-0.32px] w-[699px]">
      Know Your Worth. <br /> With this calculator, find out what you can charge
      <br /> for brand collaborations (per post)
    </h2>
  </div>
);
